import { useMutation, useQueryClient } from "@tanstack/react-query";

import { hasValue } from "@core/foundation/types";

import type { OAuthRequestId } from "@apis/account/models";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";
import { useQueries } from "../../../shared/hooks/useQueries.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useOAuthConsentActions() {
  const { api } = useAuth();

  const queryClient = useQueryClient();
  const { getOAuthRequestQueryOptions } = useQueries();
  const invalidateRequest = async (id: OAuthRequestId): Promise<void> => {
    const oauthRequestQueryOptions = getOAuthRequestQueryOptions({ id });

    await queryClient.invalidateQueries({
      queryKey: oauthRequestQueryOptions.groupQueryKey,
    });
  };

  const approve = useMutation({
    mutationFn: api.oauth.approveRequest,
    onSuccess: async (result, { id }) => {
      if (hasValue(result)) {
        window.location.href = result.redirectUrl;
      } else {
        await invalidateRequest(id);
      }
    },
  });

  const deny = useMutation({
    mutationFn: api.oauth.denyRequest,
    onSuccess: async (result, { id }) => {
      if (hasValue(result)) {
        window.location.href = result.redirectUrl;
      } else {
        await invalidateRequest(id);
      }
    },
  });

  return { approve, deny };
}
